import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from "classnames";
import ImageOpenAnswer from "../Components/imageOpenAnswer";

class Answer extends Component {
  constructor(props) {
    super(props);

    this.callbackRef = this.callbackRef.bind(this);
    this.onImgLoad = this.onImgLoad.bind(this);
    this.changeContainerHeight = this.changeContainerHeight.bind(this);
  }

  callbackRef(element) {
    if (element) {
      this.changeContainerHeight(element.clientHeight)
    }
  }

  onImgLoad({target:img}) {
    this.changeContainerHeight(img.offsetHeight);
  }

  changeContainerHeight(height) {
    const totalHeight = height + (this.props.question.stackedAnswers ? 50 : 30);

    if (totalHeight > this.props.highestAnswerHeight) {
      this.props.setHighestAnswerHeight(totalHeight)
    }
  }

  render() {
    const {answer, question, detail, isActive, handleDrop} = this.props;

    return <div className={classnames({
      "answer cafetery-wrap mr-3": true,
      "active": isActive
    })} ref={this.callbackRef} data-a={answer.id}>
      <div className={"d-flex"} style={{alignItems: "center"}}>
        {isActive && <i onClick={() => handleDrop(null, answer.id)} style={{fontSize: "18px"}} className={"fa-solid fa-circle-caret-up"} />}
        <ImageOpenAnswer
            answer={answer}
            detail={detail}
            checked={isActive}
            checkboxType={''}
            answersImage={question.answersImage}
            showInput={false}
            showContent={true}
            onOpenChange={e => this.props.onAnswerOpenChange(e.target.value)}
            answerOpenAlwaysShow={false}
        />
      </div>
      {isActive && answer.isOpen && <ImageOpenAnswer
          answer={answer}
          detail={detail}
          checked={isActive}
          checkboxType={''}
          answersImage={false}
          showInput={true}
          showContent={false}
          onOpenChange={e => this.props.onAnswerOpenChange(e.target.value)}
          answerOpenAlwaysShow={false}
      />}
    </div>
  }
}

Answer.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    answersImage: PropTypes.bool.isRequired,
    stackedAnswers: PropTypes.bool.isRequired,
  }).isRequired,
  answer: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
  }),
  detail: PropTypes.shape({
    content: PropTypes.string,
  }),
  isActive: PropTypes.bool.isRequired,
  setHighestAnswerHeight: PropTypes.func,
  highestAnswerHeight: PropTypes.number,
  onAnswerOpenChange: PropTypes.func,
};

export default Answer;